import { RouteRecordRaw } from "vue-router";

const products: RouteRecordRaw = {
  path: "products",
  component: () => import("@/views/public/index.vue"),
  meta: {
    title: "products",
  },
  children: [
    {
      path: "",
      name: "product",
      component: () => import("@/views/public/products/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "products",

      },
    },
    {
      path: "index",
      name: "product index",
      component: () => import("@/views/public/products/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "products",
      },
    },
    {
      path: "add",
      name: "Add New product",
      component: () => import("@/views/public/products/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "Edit product",
      component: () => import("@/views/public/products/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default products;
